<template>
    <div
        :class="[
            'tinymce-container',
            'editor-container',
            disabled ? 'disable' : '',
        ]"
    >
      <textarea class="tinymce-textarea" :id="id" />
    </div>
</template>
<script>
import { getImage } from '@/utils'
import tinymce from 'tinymce/tinymce'
import 'tinymce/skins/ui/oxide/skin'
import 'tinymce/themes/silver/theme'
import 'tinymce/icons/default/icons'
import 'tinymce/models/dom/model'
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/code';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/image';
const plugins = 'lists link anchor code wordcount image table visualchars visualblocks searchreplace preview pagebreak nonbreaking insertdatetime fullscreen directionality autosave autolink advlist'
const toolbar = ['styleselect bold italic underline | strikethrough undo redo  blockquote | removeformat alignleft aligncenter alignright | subscript superscript  hr bullist | numlist link image charmap preview | insertdatetime media table | emoticons forecolor backcolor ']
const Local = {
    get(key) {
        return window.localStorage.getItem(key);
    }
}
let num = 1;
export default {
    name: "Tinymce",
    props: {
        id: {
            type: String,
            default: () => {
                num === 10000 && (num = 1);
                return `tinymce${+new Date()}${num++}`;
            },
        },
        value: {
            type: String,
            default: "",
        },
        height: {
            type: Number,
            default: 200,
        },
        branding: {
            type: Boolean,
            default: false,
        },
        menubar: {
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hasChange: false,
            hasInit: false,
        };
    },
    watch: {
        value(val) {
            if (!this.hasChange && this.hasInit) {
                // eslint-disable-next-line no-undef
                this.$nextTick(() => tinymce.get(this.id).setContent(val));
            }
        },
    },
    methods: {
        getApi() {
            const { option: { api } } = this.$attrs
            if (!api) return false
            const { tinymceUploadFile } = api
            if (!tinymceUploadFile) return false
            return tinymceUploadFile
        }
    },
    mounted() {
        const _this = this;
        // 请求地址
        const tinymceUploadFile = this.getApi()
        const uploadUrl = tinymceUploadFile || "/system/file/upload";
        // eslint-disable-next-line no-undef
        tinymce.init({
            selector: `#${this.id}`,
            readonly: this.readonly || this.disabled,
            // 避免图片地址和链接地址转换成相对路径
            relative_urls: false,
            remove_script_host: false,
            convert_urls: false,
            content_css: '/tinymce/skins/ui/oxide/content.css',
            language_url: '/tinymce/langs/zh_CN.js',
            language: "zh_CN",
            width: "100%",
            height: 200,
            body_class: "panel-body",
            object_resizing: false,
            toolbar_drawer: true,
            plugins,
            toolbar,
            menubar: false,
            branding: this.branding,
            end_container_on_empty_block: true,
            autoresize_bottom_margin: 50,
            autoresize_min_height: this.height, // 编辑区域的最小高度
            autoresize_on_init: true,
            nonbreaking_force_tab: true,
            font_formats: "微软雅黑=微软雅黑,Microsoft YaHei;宋体=宋体,SimSun;黑体=黑体, SimHei;隶书=隶书, SimLi;楷体=楷体,楷体_GB2312, SimKai;andale mono=andale mono;arial=arial, helvetica,sans-serif;arial black=arial black,avant garde;comic sans ms=comic sans ms;impact=impact,chicago;Arial=Arial;Verdana=Verdana;Georgia=Georgia;Times New Roman=Times New Roman;Trebuchet MS=Trebuchet MS;Courier New=Courier New;Impact=Impact;Comic Sans MS=Comic Sans MS;Calibri=Calibri",
            fontsizeFormats: "8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 24pt 36pt 48pt",
            default_link_target: "_blank",
            link_title: false,
            images_upload_handler: function (blobInfo, progress) {
                return new Promise((resolve, reject) => {
                    const param = new FormData()
                    param.append('file', blobInfo.blob(), blobInfo.filename())
                    var xhr
                    xhr = new XMLHttpRequest();
                    xhr.withCredentials = false;
                    xhr.open("POST", uploadUrl);
                    xhr.setRequestHeader(`Authorization`, `${ Local.get('token') }`);
                    xhr.onload = function () {
                        let json;
                        if (xhr.status !== 200) {
                            throw("HTTP Error: " + xhr.status);
                        }
                        json = JSON.parse(xhr.responseText);
                        if (!json || typeof json.data.downloadUrl !== "string") {
                            throw("Invalid JSON: " + xhr.responseText);
                        }
                        resolve(getImage(json.data.downloadUrl));
                    }
                    xhr.send(param)
                })
            },
            init_instance_callback: (editor) => {
                if (_this.value) {
                    editor.setContent(_this.value);
                }
                _this.hasInit = true;
                editor.on("NodeChange Change KeyUp", () => {
                    this.hasChange = true;
                    this.$emit("input", editor.getContent({ format: "raw" }));
                });
            },
            setup(editor) {
                editor.ui.registry.addButton("h2", {
                    title: "小标题", // tooltip text seen on mouseover
                    text: "小标题",
                    onclick() {
                        editor.execCommand("mceToggleFormat", false, "h2");
                    },
                    onPostRender() {
                        const btn = this;
                        editor.on("init", () => {
                            editor.formatter.formatChanged("h2", (state) => {
                                btn.active(state);
                            });
                        });
                    },
                });
                editor.ui.registry.addButton("p", {
                    title: "正文",
                    text: "正文",
                    onclick() {
                        editor.execCommand("mceToggleFormat", false, "p");
                    },
                    onPostRender() {
                        const btn = this;
                        editor.on("init", () => {
                            editor.formatter.formatChanged("p", (state) => {
                                btn.active(state);
                            });
                        });
                    },
                });
                editor.on("joinimageuploadstart", function (e) {
                    _this.$message({ duration: 0, message: "正在上传图片..." });
                });
                editor.on("joinimageuploadend", function (e) {
                    _this.$message.closeAll();
                });
                editor.on("joinimageuploaderror", function (e) {
                    _this.$message({ duration: 0, message: e.errMsg });
                    setTimeout(function () {
                        _this.$message.closeAll();
                    }, 3000);
                });
                editor.on("paste", async (event) => {
                // 监听粘贴
                try {
                    const clipboardItems = event.clipboardData.items;
                    for (const clipboardItem of clipboardItems) {
                        const kind = clipboardItem.kind;
                        const type = clipboardItem.type;
                        if (kind === "file" && type.startsWith("image/")) {
                        // 图片
                        event.preventDefault();
                        const file = clipboardItem.getAsFile();
                        if (!file) return;
                        const param = new FormData(); // 创建form对象
                        param.append("file", file); // 通过append向form对象添加数据
                        const { option: { api } } = this.$attrs
                        const { uploadFile } = api
                        uploadFile(param).then((res) => {
                            const url = res.data.downloadUrl;
                            this.insertContent(`<img src="${url}" alt="" />`);
                        });
                        }
                    }
                } catch (error) {
                    //...
                }
            });
            },
        });
    },
    destroyed() {
        // eslint-disable-next-line no-undef
        tinymce.get(this.id).destroy();
    },
};
</script>
<style scoped>
    .tinymce-container {
        position: relative;
    }
    .tinymce-textarea {
        visibility: hidden;
        z-index: -1;
    }
    .editor-custom-btn-container {
        position: absolute;
        right: 15px;
        top: 18px;
    }
    .editor-upload-btn {
        display: inline-block;
    }
    .disable {
        pointer-events: none;
    }
</style>
  